/**
 * Instrument provider factory + Mock/Serial implementace.
 * PUSH/event model — viz baseProvider.js. HidProvider (reálná DYMO M5) je v hidProvider.js.
 *
 * Volba implementace přes ENV REACT_APP_INSTRUMENT_MODE:
 *   hid    (default) — reálná DYMO M5 přes WebHID
 *   serial          — WebSerial scaffold (zatím neimplementováno, ADR-008)
 *   mock            — simulace bez HW (dev/test)
 * Ruční zadání NENÍ provider — je to vždy dostupný UI fallback v měřicí obrazovce.
 */
import { InstrumentProvider, ConnectionState } from './baseProvider';
import { HidProvider } from './hidProvider';
import { UNIT, STATUS } from './dymoParser';

/**
 * MockProvider — push simulace pro dev/test (bez fyzického HW).
 * Po start() emituje stabilní vzorky (Weight Stable, gram) o hodnotě simWeight.
 * setSimulatedWeight() umožní dev odzkoušet vodicí flow (měřicí obrazovka ji v mock
 * režimu nastaví na aktuální cílový bod).
 */
export class MockProvider extends InstrumentProvider {
  constructor() {
    super();
    this._simWeight = 0;
    this._timer = null;
  }

  get name() { return 'Demo váha (mock)'; }

  get isMock() { return true; }

  setSimulatedWeight(grams) {
    this._simWeight = Math.round(Number(grams) || 0); // krok 1 g (rozlišení)
  }

  async connect() { this._setState(ConnectionState.CONNECTED); }

  async disconnect() { this.stop(); this._setState(ConnectionState.DISCONNECTED); }

  start() {
    if (this._timer) return;
    this._timer = setInterval(() => {
      this._emitReading({
        value: this._simWeight,
        grams: this._simWeight,
        unit: UNIT.GRAM,
        status: STATUS.STABLE,
        stable: true,
        isGram: true,
        raw: null,
        ts: Date.now(),
      });
    }, 250);
  }

  stop() {
    if (this._timer) { clearInterval(this._timer); this._timer = null; }
  }
}

/**
 * SerialProvider — placeholder (WebSerial). Reálná implementace přijde s SCPI přístrojem (ADR-008).
 */
export class SerialProvider extends InstrumentProvider {
  get name() { return 'WebSerial (real)'; }

  async connect() {
    this._setState(ConnectionState.ERROR);
    throw new Error(
      'SerialProvider zatím není implementovaný (ADR-008). Pro DYMO M5 použijte REACT_APP_INSTRUMENT_MODE=hid.'
    );
  }
}

export function createInstrumentProvider() {
  const mode = (process.env.REACT_APP_INSTRUMENT_MODE || 'hid').toLowerCase();
  if (mode === 'mock') return new MockProvider();
  if (mode === 'serial') return new SerialProvider();
  return new HidProvider(); // default
}

export { InstrumentProvider, ConnectionState } from './baseProvider';
export { HidProvider, isWebHidAvailable } from './hidProvider';
